/**
 * Layout binario compartilhado entre sealed-params.ts (node:crypto, server)
 * e sealed-params.client.ts (Web Crypto, cliente): iv + authTag + corpo,
 * nessa ordem. Os dois lados precisam ficar byte-a-byte compativeis pra
 * sempre - um valor selado de um lado tem que decifrar no outro. So os
 * comprimentos ficam aqui: o nome do algoritmo e grafado diferente em cada
 * API nativa ('aes-256-gcm' no node:crypto, 'AES-GCM' na Web Crypto do
 * navegador), entao nao da pra compartilhar como string.
 */
export const IV_LENGTH = 12
export const AUTH_TAG_LENGTH = 16
